import { applyFilter, applySearchFilter } from '../../Utils/Utils';

export const applyFilters = ({ list, filters }) => {
  let filteredList = list;
  // filter on status
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'status',
    defaultFilter: [],
  });
  // filter on commercialProductId
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'commercialProductId',
    defaultFilter: [],
  });
  // query filter on field: id
  filteredList = applySearchFilter({
    list: filteredList,
    filters,
    rowNames: ['partyName', 'id', 'contract_number'],
  });
  // filter on isOutstanding => balance_today
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'isOutstanding',
    defaultFilter: [],
  });
  // filter on currentMonth 
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'currentMonth',
    defaultFilter: [],
  });

  return filteredList;
};
